// components
import React from 'react';
import ToolIcon from '../';

import { CloseOutlined } from '@ant-design/icons';

export default props => <ToolIcon component={CloseOutlined} size="small" {...props} />;
